/* Size guide — shared page behaviour.
 *
 *   1. Audience switch  Women's / Men's, applied page-wide via a `data-size-guide-audience`
 *                       attribute on <html> so every section follows one control.
 *   2. Unit switch      In / Cm, broadcast the same way so the finder and the
 *                       reference tables can never disagree about units.
 *   3. Card carousels   arrows and dots for multi-media cards. The track itself
 *                       scroll-snaps in CSS, so swiping works without this file.
 *
 * Accordions are <details> elements and need no script at all.
 */
(function () {
  'use strict';

  /* Several size guide sections can appear on one page and each links this
     file, so the browser executes it once per tag. Bind only the first time. */
  if (window.sizeGuideUiLoaded) return;
  window.sizeGuideUiLoaded = true;


  var AUDIENCE_ATTRIBUTE = 'data-size-guide-audience';
  var UNIT_ATTRIBUTE = 'data-size-guide-unit-preference';

  /* ---------- Audience ---------- */

  function setAudience(audience) {
    document.documentElement.setAttribute(AUDIENCE_ATTRIBUTE, audience);

    document.querySelectorAll('[data-size-guide-audience-option]').forEach(function (button) {
      var selected = button.getAttribute('data-size-guide-audience-option') === audience;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    // Keep the choice in the URL so a link to "men's" opens on men's.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      if (audience === 'women') url.searchParams.delete('audience');
      else url.searchParams.set('audience', audience);
      window.history.replaceState({}, '', url);
    }
  }

  function initAudience() {
    var buttons = document.querySelectorAll('[data-size-guide-audience-option]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        setAudience(button.getAttribute('data-size-guide-audience-option'));
      });
    });

    var requested = new URLSearchParams(window.location.search).get('audience');
    setAudience(requested === 'men' ? 'men' : 'women');
  }

  /* ---------- Units ---------- */

  function setUnit(unit) {
    document.documentElement.setAttribute(UNIT_ATTRIBUTE, unit);

    document.querySelectorAll('[data-size-guide-unit-option]').forEach(function (button) {
      var selected = button.getAttribute('data-size-guide-unit-option') === unit;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    // Table cells carry both readings and reveal the active one.
    document.querySelectorAll('[data-size-guide-unit]').forEach(function (cell) {
      cell.hidden = cell.getAttribute('data-size-guide-unit') !== unit;
    });

    document.dispatchEvent(new CustomEvent('size-guide:unitchange', { detail: { unit: unit } }));
  }

  function initUnits() {
    var buttons = document.querySelectorAll('[data-size-guide-unit-option]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        setUnit(button.getAttribute('data-size-guide-unit-option'));
      });
    });

    setUnit('in');
  }

  /* ---------- Card carousels ---------- */

  function initCarousel(media) {
    var track = media.querySelector('[data-size-guide-track]');
    var slides = media.querySelectorAll('[data-size-guide-slide]');
    var dots = media.querySelectorAll('[data-size-guide-dot]');
    var previous = media.querySelector('[data-size-guide-previous]');
    var next = media.querySelector('[data-size-guide-next]');
    if (!track || slides.length < 2) return;

    var active = 0;

    function render() {
      dots.forEach(function (dot, index) {
        dot.classList.toggle('size-guide-card__dot--active', index === active);
      });
      if (previous) previous.hidden = active === 0;
      if (next) next.hidden = active === slides.length - 1;
    }

    function go(direction) {
      var target = Math.max(0, Math.min(slides.length - 1, active + direction));
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }

    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      index = Math.max(0, Math.min(slides.length - 1, index));
      if (index === active) return;
      active = index;
      render();
    });

    if (previous) previous.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    render();
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-size-guide-carousel]').forEach(initCarousel);
  }

  /* ---------- Boot ---------- */

  function init() {
    initAudience();
    initUnits();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders a section's markup in place, so re-bind what it replaced.
  document.addEventListener('shopify:section:load', function (event) {
    initCarousels(event.target);
    initAudience();
    initUnits();
  });
})();
